"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.expectationInputStateHasValidationErrors = expectationInputStateHasValidationErrors;
const constants_1 = require("./constants");
function expectationInputStateHasValidationErrors(fieldsNeedingExpectations, expectationInputs) {
    for (const field of fieldsNeedingExpectations) {
        const fieldId = field.fieldId;
        const expectationField = field.expectationField;
        const value = expectationInputs[fieldId];
        if ((expectationField === null || expectationField === void 0 ? void 0 : expectationField.expectationFieldType) === constants_1.ExpectationFieldType.RANGE) {
            const isMandatory = expectationField.mandatory;
            const min = (value === null || value === void 0 ? void 0 : value.type) === "range" ? value.min.trim() : "";
            const max = (value === null || value === void 0 ? void 0 : value.type) === "range" ? value.max.trim() : "";
            const hasMin = min !== "";
            const hasMax = max !== "";
            // ❗ Invalid if mandatory but both are empty
            if (isMandatory && !hasMin && !hasMax) {
                return true;
            }
            // If present, must be valid numbers
            const minNum = hasMin ? parseFloat(min) : undefined;
            const maxNum = hasMax ? parseFloat(max) : undefined;
            if ((hasMin && isNaN(minNum)) || (hasMax && isNaN(maxNum))) {
                return true;
            }
            // If both exist, ensure min <= max
            if (hasMin && hasMax && minNum > maxNum) {
                return true;
            }
        }
    }
    return false;
}
